import(/* webpackMode: "eager" */ "/srv/apps/internationaljobs/releases/8a1d663-202611051350/src/app/global-error.tsx");
